<template>
  <div>
    <div class="Centrebox">
      <img src="@/assets/img/logo.png" class="logo" />
      <div class="menu">
        <div v-for="(i, index) in data.menu" :key="index" class="meun-item">
          <!-- <div v-if="i.isdropdown">{{ i.title }}</div> -->
          <el-dropdown :hide-on-click="false">
            <span class="el-dropdown-link" @click="goto(i.path)">
              {{ i.title
              }}<el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  :command="ite.path"
                  v-for="(ite, ind) in i.child"
                  :key="ite.title"
                  @click="goto(ite.path,ite.path+ind)"
                >
                  {{ ite.title }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useRouter } from "vue-router";
import { getconfig } from "@/comm/api";
import { onMounted } from "vue";
export default {
  name: "myHeader",
  setup() {
    let data = reactive({
      menu: [
        {
          title: "首页",
          path: "/",
          isdropdown: true,
        },
        {
          title: "APP下载",
          path: "/download",
          isdropdown: true,
        },
        {
          title: "合作入驻",
          path: "/cooperation",
          child: [
            {
              title: "商家入驻流程",
              path: "/cooperation",
            },
            {
              title: "资质要求",
              path: "/cooperation",
            },
            {
              title: "代运营服务商入驻",
              path: "/cooperation",
            },
          ],
        },
        {
          title: "热点新闻",
          path: "/news",
          child: [
            {
              title: "热点新闻",
              path: "/news",
            },
            {
              title: "超拼新闻",
              path: "/news",
            },
            {
              title: "行业新闻",
              path: "/news",
            },
          ],
        },
        {
          title: "关于我们",
          path: "/user",
          child: [
            {
              title: "公司简介",
              path: "/user",
            },
            {
              title: "核心团队",
              path: "/user",
            },
            {
              title: "发展大事记",
              path: "/user",
            },
            {
              title: "社会荣誉",
              path: "/user",
            },
            {
              title: "加入我们",
              path: "/wanted",
            },
          ],
        },
        {
          title: "超拼科技",
          path: "all",
          isdropdown: true,
        },
      ],
      chaoPinLink: "",
    });
    const router = useRouter();

    const goto = (path,id) => {
      if (path != "all") {
        router.push(path);
        if (id) {
          const el = document.getElementById(id);
          if (el) {
            // 使用window.scrollTo实现平滑滚动
            window.scrollTo({
              top: el.offsetTop,
              behavior: "smooth",
            });
          }
        }
      } else {
        window.open(data.chaoPinLink);
      }
    };
    const getconfigFn = async (configName) => {
      try {
        const res = await getconfig({ configName: configName });
        console.log(1, res);
        if (res.code == 1) {
          data[configName] = res.data;
        }
      } catch (err) {
        console.error("失败", err);
      }
    };
    onMounted(() => {
      getconfigFn("chaoPinLink");
    });

    return {
      data,
      goto,
      getconfigFn,
    };
  },
};
</script>

<style lang="scss" scoped>
.Centrebox {
  width: 1200px;
  height: 50px;
  margin: 50px auto;
  padding-top: 50px;
  z-index: 999999999;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Centrebox .menu {
  display: flex;
  align-content: center;
}

.Centrebox .menu .meun-item {
  padding: 0px 10px;
  color: #ffff !important;
}

:deep(.el-dropdown) {
  color: #ffff;
  border: none !important;
  cursor: pointer;
}
.el-dropdown:hover {
  color: #409eff !important;
  animation: 0.9s ease 0s 1 normal both running jello-horizontal;
}
@-webkit-keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
@keyframes jello-horizontal {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
  30% {
    -webkit-transform: scale3d(1.25, 0.75, 1);
    transform: scale3d(1.25, 0.75, 1);
  }
  40% {
    -webkit-transform: scale3d(0.75, 1.25, 1);
    transform: scale3d(0.75, 1.25, 1);
  }
  50% {
    -webkit-transform: scale3d(1.15, 0.85, 1);
    transform: scale3d(1.15, 0.85, 1);
  }
  65% {
    -webkit-transform: scale3d(0.95, 1.05, 1);
    transform: scale3d(0.95, 1.05, 1);
  }
  75% {
    -webkit-transform: scale3d(1.05, 0.95, 1);
    transform: scale3d(1.05, 0.95, 1);
  }
  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}
.example-showcase .el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}
@media screen and (max-width: 1800px) {
  // 当屏幕宽度小于等于 600px 时应用的样式
  .Centrebox {
    margin-top: 50px;
  }
}
:deep(.el-dropdown),
:deep(.el-dropdown *) {
  outline: none;
}
</style>